import React from 'react';
import Icon from 'icon';
import s from './hero_miscellaneous.module.scss';

export default function HeroMiscellaneous({ ...props }) {
  const date = new Date();
  const month = date.getMonth();
  let monthInWords = '';
  switch (month) {
    case 0:
      monthInWords = 'Jan';
      break;
    case 1:
      monthInWords = 'Feb';
      break;
    case 2:
      monthInWords = 'Mar';
      break;
    case 3:
      monthInWords = 'Apr';
      break;
    case 4:
      monthInWords = 'May';
      break;
    case 5:
      monthInWords = 'Jun';
      break;
    case 6:
      monthInWords = 'Jul';
      break;
    case 7:
      monthInWords = 'Aug';
      break;
    case 8:
      monthInWords = 'Sept';
      break;
    case 9:
      monthInWords = 'Oct';
      break;
    case 10:
      monthInWords = 'Nov';
      break;
    case 11:
      monthInWords = 'Dec';
      break;
      default:
      break;
  }
  return (
    <div className={s.miscellaneous}>
      <div className={s.tag}>
        <Icon className={s.icon} icon="user" />
        <p
          className={s.paragraph}
          dangerouslySetInnerHTML={{ __html: 'Furlough Group' }}
        />
      </div>
      <div className={s.tag}>
        <Icon className={s.icon} icon="clock" />
        <p
          className={s.paragraph}
          dangerouslySetInnerHTML={{ __html: `${monthInWords} ${date.getDate()}, ${date.getFullYear()}` }}
        />
      </div>
      <div className={s.tag}>
        <Icon className={s.icon} icon="link-round" />
        <a
          className={`${s.paragraph} ${s.last}`}
          href="https://www.instagram.com/furlough"
          rel="noopener noreferrer"
          target="_blank"
          dangerouslySetInnerHTML={{ __html: '@furlough' }}
        />
      </div>
    </div>
  );
}
